import axios, { API_URL } from './BaseService';

const SYMBOLS_URL = `${API_URL}/symbols`;

export async function getSymbols(onlyFavorites = false) {
    const url = onlyFavorites ? `${SYMBOLS_URL}?onlyFavorites=${onlyFavorites}` : SYMBOLS_URL;
    const response = await axios.get(url);
    return response.data;
}

export async function searchSymbols(search, onlyFavorites, page) {
    const response = await axios.get(`${SYMBOLS_URL}/`, {
        params: {
            search: search || '',
            page: page || 1,
            onlyFavorites: onlyFavorites || false,
            pageSize: 20
        }
    });
    return response.data;
}

export async function getSymbol(symbol) {
    const response = await axios.get(`${SYMBOLS_URL}/${symbol}`);
    return response.data;
}

export async function updateSymbol(symbolData) {
    const response = await axios.patch(`${SYMBOLS_URL}/${symbolData.symbol}`, symbolData);
    return response.data;
}

export async function syncSymbols() {
    const response = await axios.post(`${SYMBOLS_URL}/sync`, {});
    return response.data;
}
